module.exports = __webpack_public_path__ + "../panel-assets/img/FinHubLogo.75f51935.svg";